module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Deep Six Design","short_name":"Deep Six","start_url":"/","background_color":"#fff","theme_color":"#FF1654","display":"fullscreen","icon":"src/images/logo.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-firebase/gatsby-browser.js'),
      options: {"plugins":[],"features":{"auth":true,"database":false,"firestore":true,"storage":true,"messaging":true,"functions":true,"performance":true,"analytics":true},"credentials":{"apiKey":"AIzaSyBthjo010WXl-F73mHUAdNyQzBbUGvVHPA","authDomain":"deepsixdesign-web-dev.firebaseapp.com","databaseURL":"","projectId":"deepsixdesign-web-prod","storageBucket":"deepsixdesign-web-prod.appspot.com","appId":"_F_APPID","measurementId":"G-C23LM2M6FZ"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
